// extracted by css-extract-rspack-plugin
export default {"chartLegendInfo":"chart-legend-info--gX0WT9GqUSkXlWCW","chartLegendInfoCircle":"chart-legend-info-circle--dfp0zubySWMA65O8"};